module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_enpgames.ae06ec0d8e45a673f4653b84c801e1fd.png";